import { DashboardDesktopView } from './DashboardDesktopView';

export function DashboardMobileView() {
  return <DashboardDesktopView />;
}
